import Vue from 'vue'
import Router from 'vue-router'
import Discover from '@/views/discover'
import lists from '@/views/lists'
import singleEbookPage from '@/views/single-ebook-page'
import main from '@/views/main'
import Signin from '@/views/signin'
import Signup from '@/views/signup'
import SendChapter from '@/views/send-chapter'
import Subscription from '@/views/subscription'
import PrivacyPolicy from '@/views/privacy-policy'
import pdfViewer from '@/views/pdf-viewer'
import Profile from '@/views/profile'
import TermsService from '@/views/terms-service'
import firebaseService from '@/services/firebase.service'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/discover',
      name: 'Discover',
      component: Discover,
      meta: { showFooter: true }
    },
    {
      path: '/ebook/:ebookCode',
      name: 'SingleEbookPage',
      component: singleEbookPage,
      props: true,
      meta: { showFooter: true }
    },
    {
      path: '/lists',
      name: 'ListsIndex',
      component: Discover,
      meta: { showFooter: true }
    },
    {
      path: '/lists/:listUriParam',
      name: 'lists',
      component: lists,
      props: true,
      meta: { showFooter: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { requiresAuth: true, showFooter: true }
    },
    {
      path: '/pdf/:pdfId',
      name: 'pdf',
      component: pdfViewer,
      props: true,
      meta: { requiresAuth: true, showFooter: true }
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: { showFooter: true }
    },
    {
      path: '/send',
      name: 'SendChapter',
      component: SendChapter,
      meta: { showFooter: true }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: { unauthenticated: true }
    },
    {
      path: '/subscription',
      name: 'Subscription',
      component: Subscription,
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      name: 'main',
      component: main,
      meta: { showFooter: true }
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin,
      meta: { unauthenticated: true }
    },
    {
      path: '/terms',
      name: 'TermsService',
      component: TermsService,
      meta: { showFooter: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const unauthenticated = to.matched.some(record => record.meta.unauthenticated)
  const showFooter = !!to.meta.showFooter

  const isAuthenticated = firebaseService.auth().currentUser
  if (requiresAuth && !isAuthenticated) {
    next('/signin')
  } else if (unauthenticated && isAuthenticated) {
    next('/')
  } else {
    store.dispatch('toggleFooter', showFooter)
    next()
  }
})

export default router
